import { useEffect, useState } from "react";
import { connect, RootStateOrAny } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { RouteComponentProps, useHistory } from "react-router";

import { Breadcrumb, Typography } from "antd";
import { EditOutlined, HomeOutlined } from "@ant-design/icons";

import {
  getSubmitted,
  cancel,
  getSubmittedUsingEdifecs,
} from "store/claim/actions";
import { reportIssue } from "store/app/actions";
import { getHelpCenterLinks } from "store/app/helpCenter/actions";

import { ClaimList } from "utils/enums";
import { ErrorResponse } from "utils/types";
import notifier from "utils/notifier";

import SubmittedClaimsTable from "components/Claims/SubmittedClaims/SubmittedClaimsTable";
import ClaimDetail from "components/Claims/SubmittedClaims/SubmittedClaimDetail";
import SubmittedClaimsForm from "components/Claims/SubmittedClaims/SubmittedClaimsForm";
import HelpCenterLink from "components/Common/HelpCenterLink";

import styles from "./SubmittedClaims.module.scss";

const { Title } = Typography;

export type SubmittedClaimsPageProps = RouteComponentProps<any> & {
  getSubmitted(userId: string): any;
  getSubmittedUsingEdifecs(searchObject: Object): any;
  isFetchingSubmitted: boolean;
  cancel(cancelClaimData: Object): any;
  isCanceling: boolean;
  isSearching: boolean;
  reportIssue(form: Object): any;
  isReporting: boolean;
  getHelpCenterLinks(companyId: string, page: string, type: string): any;
};

const SubmittedClaimsPage = (props: SubmittedClaimsPageProps) => {
  const history = useHistory();

  const [page, setPage] = useState("start");
  const [claimNo, setClaimNo] = useState("");
  const [companyId, setCompanyId] = useState("");
  const [dataSource, setDataSource] = useState<any[]>([]);
  const [helpCenter, setHelpCenter] = useState<any>([]);


  useEffect(() => {
    getHelpCenterLinks();
  },[]);

  const getHelpCenterLinks = () => {
    props
      .getHelpCenterLinks(
        sessionStorage.getItem("ipaGroup")!,
        "/claims/submitted-claims",
        "page"
      )
      .then((response: any) => {
        setHelpCenter(response);
      })
      .catch((err: ErrorResponse) => {
        console.log(err?.response?.data?.Message);
      });
  };

  return (
    <div className={styles["submitted-claims-page"]}>
      <div className={styles["header-title"]}>
        <Title level={4}>&nbsp;&nbsp;&nbsp;Submitted Portal Claims</Title>
      </div>

      {page === "start" && (
        <>
          <div>
            <Breadcrumb>
              <Breadcrumb.Item>
                <HomeOutlined
                  onClick={() => history.push("/quality/overview")}
                />
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <EditOutlined />
                <a href="#">Submitted Portal Claims</a>
              </Breadcrumb.Item>
            </Breadcrumb>
            {helpCenter?.length > 0
              ? helpCenter.map((hc: any) => {
                  return (
                    <>
                      <div className={`row ${styles["help-center-link"]}`}>
                        <div className="col-md-24">
                          <HelpCenterLink
                            clickEventId={hc.ClickEventId}
                            linkName={hc.LinkName}
                            pagePath={hc.PagePath}
                            url={hc.Link}
                            companyId={hc.CompanyId}
                          />
                        </div>
                      </div>
                    </>
                  );
                })
              : null
            }
          </div>

          <div className={styles["search-section"]}>
            <SubmittedClaimsForm
              isFetchingSubmitted={props.isFetchingSubmitted}
              getSubmitted={props.getSubmittedUsingEdifecs}
              setDataSource={setDataSource}
            />
          </div>

          <div className={styles["content"]}>
            {dataSource.length === ClaimList.SubmittedClaimMaxLimit && (
              <p>
                Search results are limited to recent 1000 items. If you dont
                find what you were looking for, try again using more specific
                search terms.
              </p>
            )}
            <SubmittedClaimsTable
              dataSource={dataSource}
              isFetchingSubmitted={props.isFetchingSubmitted}
              cancel={props.cancel}
              isCanceling={props.isCanceling}
              setPage={setPage}
              setClaimNo={setClaimNo}
              setCompanyId={setCompanyId}
            />
          </div>
        </>
      )}

      {page === "detail" && (
        <>
          <div>
            <Breadcrumb>
              <Breadcrumb.Item>
                <HomeOutlined
                  onClick={() => history.push("/quality/overview")}
                />
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <EditOutlined />
                <a onClick={() => setPage("start")}>Submitted Portal Claims</a>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <EditOutlined />
                <a>Claim Detail</a>
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>

          <ClaimDetail
            claimNo={claimNo}
            setClaimNo={setClaimNo}
            companyId={companyId}
            setPage={setPage}
          />
        </>
      )}
    </div>
  );
};

const mapStateToProps = (store: RootStateOrAny) => ({
  isFetchingSubmitted: store.rootReducer.claim.isFetchingSubmitted,
  isCanceling: store.rootReducer.claim.isCanceling,
  isReporting: store.rootReducer.app.isReporting,
  isSearching: store.rootReducer.claim.isSearching,
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      getSubmitted,
      getSubmittedUsingEdifecs,
      cancel,
      reportIssue,
      getHelpCenterLinks,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SubmittedClaimsPage);
